export const SCROLL_EDGE_TOLERANCE_PX = 1;

export const getDataTableScrollContainer = (containerRef: HTMLElement | null): HTMLElement | null =>
    containerRef?.querySelector<HTMLElement>('.p-datatable-table-container') ?? null;

export const getDataTableFrozenColumn = (containerRef: HTMLElement | null): HTMLElement | null =>
    containerRef?.querySelector<HTMLElement>('[data-p-frozen-column="true"]') ?? null;
